import { render, staticRenderFns } from "./TextTwoCol.vue?vue&type=template&id=d5252f1e&scoped=true&"
import script from "./TextTwoCol.vue?vue&type=script&lang=js&"
export * from "./TextTwoCol.vue?vue&type=script&lang=js&"
import style0 from "./TextTwoCol.vue?vue&type=style&index=0&id=d5252f1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5252f1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCol,VContainer,VImg,VProgressCircular,VRow,VSheet})
